import apiClient from "../utils/apiClient";
import {
  LOAD_ALL_SUBSCRIPTIONS_REQUEST,
  LOAD_ALL_SUBSCRIPTIONS_SUCCESS,
  LOAD_ALL_SUBSCRIPTIONS_FAIL,
  ADD_SUBSCRIPTION_REQUEST,
  ADD_SUBSCRIPTION_SUCCESS,
  ADD_SUBSCRIPTION_RESET,
  ADD_SUBSCRIPTION_FAIL,
  SUBSCRIPTION_DETAIL_REQUEST,
  SUBSCRIPTION_DETAIL_SUCCESS,
  SUBSCRIPTION_DETAIL_FAIL,
  UPDATE_SUBSCRIPTION_REQUEST,
  UPDATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_FAIL,
  DELETE_SUBSCRIPTION_REQUEST,
  DELETE_SUBSCRIPTION_SUCCESS,
  DELETE_SUBSCRIPTION_FAIL,
  /**
   * List student subscriptions
   */
  LIST_STUDENT_SUBSCRIPTIONS_REQUEST,
  LIST_STUDENT_SUBSCRIPTIONS_SUCCESS,
  LIST_STUDENT_SUBSCRIPTIONS_FAIL,
  /**
   * Add student subscription (admin assigns)
   */
  ADD_STUDENT_SUBSCRIPTION_REQUEST,
  ADD_STUDENT_SUBSCRIPTION_SUCCESS,
  ADD_STUDENT_SUBSCRIPTION_FAIL,
  /**
   * Delete student subscription
   */
  DELETE_STUDENT_SUBSCRIPTION_REQUEST,
  DELETE_STUDENT_SUBSCRIPTION_SUCCESS,
  DELETE_STUDENT_SUBSCRIPTION_FAIL,
  CLEAR_ERRORS,
} from "../constants/adminSubscriptionConstants";
// apiClient baseURL is configured in src/utils/apiClient.js

//get all subscriptions
export const getSubscriptions = () => async (dispatch) => {
  try {
    dispatch({
      type: LOAD_ALL_SUBSCRIPTIONS_REQUEST,
    });

  const { data } = await apiClient.get(`/admin/subscriptions`);

    dispatch({
      type: LOAD_ALL_SUBSCRIPTIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LOAD_ALL_SUBSCRIPTIONS_FAIL,
      payload: error.response.data.errMessage,
    });
  }
};

export const addSubscription =
  (
    examType,
    title,
    numOfQuestions,
    subscriptionType,
    duration,
    price,
    description,
    status
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ADD_SUBSCRIPTION_REQUEST,
      });
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const { data } = await apiClient.post(
        `/admin/subscriptions/add`,
        {
          examType,
          title,
          numOfQuestions,
          subscriptionType,
          duration,
          price,
          description,
          status,
        },
        config
      );
      dispatch({
        type: ADD_SUBSCRIPTION_SUCCESS,
        payload: data.user,
      });
    } catch (error) {
      dispatch({
        type: ADD_SUBSCRIPTION_FAIL,
        payload: error.response.data.errMessage,
        errors: error.response.data,
      });
    }
  };

//get subscription detail
export const getSubscriptionDetail = (id) => async (dispatch) => {
  try {
    dispatch({
      type: SUBSCRIPTION_DETAIL_REQUEST,
    });

  const { data } = await apiClient.get(`/admin/subscriptions/${id}`);
    // console.log('data ', data)
    dispatch({
      type: SUBSCRIPTION_DETAIL_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: SUBSCRIPTION_DETAIL_FAIL,
      payload: error.response.data.errMessage,
    });
  }
};

// Update subscription
export const updateSubscription =
  (
    subscriptionId,
    examType,
    title,
    numOfQuestions,
    duration,
    subscriptionType,
    price,
    description,
    status
  ) =>
  async (dispatch) => {
    // console.log('status ', status);
    try {
      dispatch({
        type: UPDATE_SUBSCRIPTION_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await apiClient.put(
        `/admin/subscriptions/update/${subscriptionId}`,
        {
          subscriptionId,
          examType,
          title,
          numOfQuestions,
          duration,
          subscriptionType,
          price,
          description,
          status,
        },
        config
      );

      dispatch({
        type: UPDATE_SUBSCRIPTION_SUCCESS,
        payload: data.success,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_SUBSCRIPTION_FAIL,
        payload: error.response.data.errMessage,
      });
    }
  };

// Delete subscription
export const deleteSubscriptionData = (subscriptionId) => async (dispatch) => {
  //console.log('userData ', userData);
  try {
    dispatch({
      type: DELETE_SUBSCRIPTION_REQUEST,
    });

    const { data } = await apiClient.delete(`/admin/subscriptions/${subscriptionId}`);

    dispatch({
      type: DELETE_SUBSCRIPTION_SUCCESS,
      subscriptionId,
      //payload: data.success
    });
  } catch (error) {
    dispatch({
      type: DELETE_SUBSCRIPTION_FAIL,
      payload: error.response.data.errMessage,
    });
  }
};

/**
 * List all student subscriptions
 */
export const getStudentSubscriptions = () => async (dispatch) => {
  try {
    dispatch({
      type: LIST_STUDENT_SUBSCRIPTIONS_REQUEST,
    });

    const { data } = await apiClient.get(`/admin/students-subscriptions`);
    dispatch({
      type: LIST_STUDENT_SUBSCRIPTIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LIST_STUDENT_SUBSCRIPTIONS_FAIL,
      payload: error.response.data.errMessage,
    });
  }
};

/**
 * Admin assigns subscription to a student
 */
export const addStudentSubscription =
  (userId, subscriptionId, examId, universityId) => async (dispatch) => {
    try {
      dispatch({
        type: ADD_STUDENT_SUBSCRIPTION_REQUEST,
      });
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const { data } = await apiClient.post(
        `/admin/students-subscriptions/add`,
        {
          userId,
          subscriptionId,
          examId,
          universityId,
        },
        config
      );
      dispatch({
        type: ADD_STUDENT_SUBSCRIPTION_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: ADD_STUDENT_SUBSCRIPTION_FAIL,
        payload: error.response?.data?.errMessage || "Failed to assign subscription",
      });
    }
  };

/**
 * Admin deletes/revokes a student subscription
 */
export const deleteStudentSubscription = (id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_STUDENT_SUBSCRIPTION_REQUEST,
    });

    const { data } = await apiClient.delete(`/admin/students-subscriptions/${id}`);
    dispatch({
      type: DELETE_STUDENT_SUBSCRIPTION_SUCCESS,
      payload: id,
    });
  } catch (error) {
    dispatch({
      type: DELETE_STUDENT_SUBSCRIPTION_FAIL,
      payload: error.response?.data?.errMessage || "Failed to delete subscription",
    });
  }
};

//clear errors
export const clearErrors = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ERRORS,
  });
};
